export enum KeyType {
  MENU = 'MENU',
  EXIT = 'EXIT',
  HOME = 'HOME',
  DOWN = 'DOWN',
  UP = 'UP',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  ENTER = 'ENTER',
  BACK = 'BACK',
  RED = 'RED',
  GREEN = 'GREEN',
  YELLOW = 'YELLOW',
  BLUE = 'BLUE',
  CH_UP = 'CH_UP',
  CH_DOWN = 'CH_DOWN',
  NUM_0 = 'NUM_0',
  NUM_1 = 'NUM_1',
  NUM_2 = 'NUM_2',
  NUM_3 = 'NUM_3',
  NUM_4 = 'NUM_4',
  NUM_5 = 'NUM_5',
  NUM_6 = 'NUM_6',
  NUM_7 = 'NUM_7',
  NUM_8 = 'NUM_8',
  NUM_9 = 'NUM_9',
  INPUT = 'INPUT',
  STOP = 'STOP',
  PLAY = 'PLAY',
  PAUSE = 'PAUSE',
  FAST_FORWARD = 'FAST_FORWARD',
  REWIND = 'REWIND',
  VOL_UP = 'VOL_UP',
  VOL_DOWN = 'VOL_DOWN',
  MUTE = 'MUTE',
}

export enum CustomKeyType {
  POWER_ON = 'POWER_ON',
  POWER_OFF = 'POWER_OFF',
  CUSTOM_TV = '201801', // TV (to TV mosaic page)
  CUSTOM_CHROMECAST = '201802', // Chromecast (to QR code pairing page)
  CUSTOM_AIRPLAY = '201803', // Airplay (to QR code pairing page)
  CUSTOM_BLUETOOTH = '201804', // Bluetooth (through HDMI input 3 on the TV)
  CUSTOM_INPUT = '201805', // HDMI input (through HDMI input 3 on the TV)
  CUSTOM_AIRTIME = '201806', // Movie (Airtime)
}
